import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ShareView } from "./components/ShareView";
import "./styles.css";

// A ?share= token boots the read-only screening room instead of the workspace.
const shareToken = new URLSearchParams(window.location.search).get("share");

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    {shareToken ? <ShareView token={shareToken} /> : <App />}
  </StrictMode>
);
